import {WebCallService} from "@/utilities/services/WebCallService";
import {PathHelper} from "@/utilities/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/enums/Enums";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import GeneralRequest from "@/models/api/GeneralRequest";
import GeneralResponse from "@/models/api/GeneralResponse";
import ServiceConfig from "@/models/entities/ServiceConfig";

// noinspection DuplicatedCode
export default class ConfigService{
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async get(errorLocationType:ErrorLocationType):Promise<ServiceConfig|null>{
        const uri = this.uriHelper.config.getConfigurationPath();
        const requestBody = new GeneralRequest({});

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (!resp || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as ServiceConfig;
    }

    public async update(config:ServiceConfig, errorLocationType:ErrorLocationType):Promise<ServiceConfig|null>{
        const uri = this.uriHelper.config.getUpdateConfigurationPath();
        const requestBody = new GeneralRequest(config);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (!resp || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as ServiceConfig;
    }
}